var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[(_vm.viewType==0)?_vm._t("discountPercent"):_vm._t("discountCurrency"),_c('button',{class:[
            _vm.$style.toggleButton,
            ( _obj = {}, _obj[_vm.$style.toggleButton_view_percent] = _vm.viewType==0, _obj ),
            ( _obj$1 = {}, _obj$1[_vm.$style.toggleButton_view_currency] = _vm.viewType==1, _obj$1 ) ],on:{"click":_vm.onChangeViewType}},[_c('svg',[(_vm.viewType==1)?_c('use',{attrs:{"xlink:href":"#gnzs-1c-icon__coins"}}):_c('use',{attrs:{"xlink:href":"#gnzs-1c-icon__percent"}})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }